import { PromotionsService } from './promotions.service';

/**
 * Centralized preloader for any data that should be prefetched at app startup.
 * Extend this service with more preload targets as needed.
 */
export const DataPreloadService = {
    /**
     * Preload essential app-wide data (e.g., promotions, banners, configurations).
     * Should be called once after app settings and cookies are initialized.
     */
    preloadEssentialData() {
        PromotionsService.loadLtPromotions();
        Tools.log('Preloaded essential data');
    },
};
